var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layerShown)?_c('div',{staticClass:"presentation-layer"},[(true)?_c('div',{staticClass:"control-and-editor"},[_c('EditorContent')],1):_vm._e(),_vm._v(" "),_c('PresentationControls')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae14c77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draftPreview/presentationLayer.vue
// module id = null
// module chunks = 